import React from "react";
import BaseButton from "../BaseButton";

export default function PriceToggleBox({
  children,
  margin = "right",
  onToggle
}) {
  const m = margin === "right" ? "mr" : "ml";
  return (
    <BaseButton className="w-1/2" onClick={onToggle}>
      <div
        className={`w-full flex flex-col items-center ${m}-2 justify-around bg-white rounded py-2`}
      >
        {children}
      </div>
    </BaseButton>
  );
}



// WEBPACK FOOTER //
// ./src/PriceToggleBox/PriceToggleBox.js